import {Component, EventEmitter, Input, Output, ElementRef, } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import {CropperPosition} from "ngx-image-cropper/src/image-cropper.component";

@Component({
    selector: 'choose-image',
    template: require('./choose-image.component.html'),
    styles: [require('./choose-image.component.css')]
})

export class ChooseImageComponent  {
    @Input() dialog: DialogRef;
    @Input() imageSource: string;
    @Input() maxWidth: number;
    @Input() aspectRatio: number = 1;
    @Output() chosenImage = new EventEmitter<string>();
    croppedImage: string = '';
    cropperPos: CropperPosition = {
         x1: -100,
         y1: -100,
         x2: 1000,
         y2: 1000
     };

    constructor(private elementRef: ElementRef) {

    }

    btnClicked(event) {
        if (event == 'save') {
            this.chosenImage.emit(this.croppedImage.replace('data:image/png;base64,', ''));
            this.closeWindow(true);
        } else {
            this.chosenImage.emit(null);
            this.closeWindow(false);
        }
    }

    shouldMaintainAspectRation() {
        return this.aspectRatio != 1;
    }

    imageCropped(image: string) {
        this.croppedImage = image;
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }

    imageLoaded() {
        setTimeout(() => {
            this.setCropper();
        }, 150);
    }

    setCropper() {
        const el = this.elementRef.nativeElement.querySelector('.source-image');
        let imageWidth = el.offsetWidth;
        let imageHeight = el.offsetHeight;
        this.cropperPos = {
            x1: 0,
            y1: 0,
            x2: imageWidth,
            y2: imageHeight
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/choose-image.component.ts